import { useSelector } from 'react-redux';
import { positionSelector } from '../store/reducers/positionSlice/positionSlice';
import { getLag } from '../helpers/getLag';
import moment from 'moment';

export const useUpdateConnectionPositions = () => {
    const allPositions = useSelector(positionSelector.selectEntities);

    const updateFollowers = (position, allPosition = allPositions, planned) => {
        let result = { ...allPosition };
        const followers = position.connections
            .filter((connection) => connection.type === 1 && connection.from === position.guid)
            .map((connection) =>
                allPosition[connection.to]
                    ? allPosition[connection.to]
                    : allPositions[connection.to]
            )
            .filter((position) => position.planned.days_count);

        if (!followers.length) {
            return result;
        }

        followers.forEach((follower) => {
            const followerEndDate = follower.planned.end_date;
            const positionStartDate = position.planned.start_date;

            const diff = moment(positionStartDate).diff(
                moment(followerEndDate).add(1, 'days'),
                'days'
            );

            let plannedFollower = {
                ...follower.planned,
            };

            if (diff < 0) {
                const updatedFollowerStart = moment(follower.planned.start_date)
                    .add(diff, 'days')
                    .format();
                const updatedFollowerEnd = moment(follower.planned.end_date)
                    .add(diff, 'days')
                    .format();
                plannedFollower = {
                    ...follower.planned,
                    start_date: updatedFollowerStart,
                    end_date: updatedFollowerEnd,
                };
                const diffStartParent = moment(updatedFollowerStart).diff(
                    moment(planned?.start_date),
                    'days'
                );

                if (diffStartParent < 0) {
                    plannedFollower = {
                        days_count: `${+follower.planned.days_count + diffStartParent}`,
                        start_date: planned.start_date,
                        end_date: moment(planned?.start_date)
                            .add(+follower.planned.days_count + diffStartParent - 1, 'days')
                            .format(),
                    };
                }

                result[follower.guid] = { ...follower, planned: plannedFollower };
            }
        });
        return result;
    };

    const updateConnectionPositions = (position, allPosition = allPositions, plannedParent) => {
        const result = { ...allPosition };

        const isFromConnection = position.connections.some(
            (connection) => connection.from === position.guid
        );

        const isFollower = position.connections.some(
            (connection) => connection.to === position.guid && connection.type === 1
        );

        if (isFromConnection) {
            const connection = position.connections.find(
                (connection) => connection.from === position.guid && connection.type === 0
            );

            if (!connection) {
                return result;
            }

            if (!result[connection.to]) {
                return result;
            }

            const positionTo = result[connection.to];
            const lag = getLag(positionTo.planned.start_date, position.planned.end_date);

            const startDate = moment(positionTo.planned.start_date).add(-lag, 'days').format();

            const endDate = moment(positionTo.planned.end_date).add(-lag, 'days').format();

            const planned = {
                ...positionTo.planned,
                start_date: startDate,
                end_date: endDate,
            };

            const updatePosition = { ...positionTo, planned };

            const updatedPositions = {
                ...result,
                [updatePosition.guid]: updatePosition,
            };

            const followerResult = updateFollowers(position, updatedPositions, plannedParent);

            return updateConnectionPositions(
                updatePosition,
                { ...updatedPositions, ...followerResult },
                plannedParent
            );
        } else if (isFollower) {
            const connection = position.connections.find(
                (connection) => connection.to === position.guid && connection.type === 1
            );
            const positionFrom = result[connection.from];

            const isPositionFromOtherItem = !!positionFrom;

            if (!connection || !isPositionFromOtherItem) {
                return result;
            }

            const lag = getLag(positionFrom.planned.start_date, position.planned.end_date);

            const startDate = moment(positionFrom.planned.start_date).add(-lag, 'days').format();
            const endDate = moment(positionFrom.planned.end_date).add(-lag, 'days').format();

            const planned = {
                ...positionFrom.planned,
                start_date: startDate,
                end_date: endDate,
            };

            const updatePosition = { ...positionFrom, planned };

            const updatedPositions = {
                ...result,
                [updatePosition.guid]: updatePosition,
            };

            const followerResult = updateFollowers(position, updatedPositions, plannedParent);
            return updateConnectionPositions(
                updatePosition,
                { ...updatedPositions, ...followerResult },
                plannedParent
            );
        } else {
            if (isFollower) {
                const connection = position.connections.find(
                    (connection) => connection.to === position.guid && connection.type === 1
                );

                if (!connection) {
                    return result;
                }
                const positionFrom = result[connection.from];

                const lag = getLag(positionFrom.planned.start_date, position.planned.end_date);

                const startDate = moment(positionFrom.planned.start_date)
                    .add(-lag, 'days')
                    .format();
                const endDate = moment(positionFrom.planned.end_date).add(-lag, 'days').format();

                const planned = {
                    ...positionFrom.planned,
                    start_date: startDate,
                    end_date: endDate,
                };

                const updatePosition = { ...positionFrom, planned };

                const updatedPositions = {
                    ...result,
                    [updatePosition.guid]: updatePosition,
                };

                const followerResult = updateFollowers(position, updatedPositions, plannedParent);
                return updateConnectionPositions(
                    updatePosition,
                    { ...updatedPositions, ...followerResult },
                    plannedParent
                );
            } else {
                return result;
            }
        }
    };

    return { updateConnectionPositions };
};
